// Auto generated file, do not manually modify!
// com.hotpads.cometdtos.styledcomponent.enums.AlertTone

export enum AlertTone {
  CRITICAL = 'CRITICAL',
  INFO = 'INFO',
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING',
}

export const AlertTone_values = [AlertTone.CRITICAL, AlertTone.INFO, AlertTone.SUCCESS, AlertTone.WARNING] as const;
